import { useCallback } from 'react'

import { useAuthUser } from '~/hooks/useAuthUser'
import { useNavigation } from '~/hooks/useNavigation'
import { useCookieStore } from '~/store/cookieStore'

export const useResetActiveOrg = () => {
  const { user } = useAuthUser()
  const navigate = useNavigation()
  const setActiveOrgId = useCookieStore((s) => s.setActiveOrgId)
  const firstOrgId = user?.orgs[0]?.id

  return useCallback(() => {
    if (firstOrgId) {
      setActiveOrgId(firstOrgId)
      navigate('/')
    }
  }, [firstOrgId, setActiveOrgId, navigate])
}
